import {
  BAJAJ_QUEUE_LOAD,
  BAJAJ_QUEUE_UPDATE,
  BAJAJ_QUEUE_ERROR,
  BAJAJ_DOCTOR_STATE_SET,
  BAJAJ_CALL_STARTED,
} from '../actions/bajajQueue';

const defaultState = {
  stats: {},
  queue: [],
  doctors: [],
  doctorStatus: null,
  assignedCase: null,
  activeCall: null,
  error: null,
};

export default function bajajQueue(state = defaultState, action) {
  switch (action.type) {
    case BAJAJ_QUEUE_LOAD:
    case BAJAJ_QUEUE_UPDATE:
      return {
        ...state,
        stats: action.payload.stats || state.stats,
        queue: action.payload.queue || state.queue,
        doctors: action.payload.doctors || state.doctors,
        error: null,
      };

    case BAJAJ_DOCTOR_STATE_SET:
      return {
        ...state,
        doctorStatus: action.payload.doctorStatus || state.doctorStatus,
        assignedCase: action.payload.assignedCase,
        error: null,
      };

    case BAJAJ_CALL_STARTED:
      return {
        ...state,
        activeCall: action.payload,
        doctorStatus: { ...(state.doctorStatus || {}), status: 'IN_CALL' },
      };

    case BAJAJ_QUEUE_ERROR:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
